import { type SyncResumeStatusResponse } from "../api";
import { SyncStatus } from "./sync_status";

export interface ResumeSyncStatus extends SyncResumeStatusResponse {}

export class ResumeSyncStatus extends SyncStatus<ResumeSyncStatus> {
  constructor(init?: Partial<SyncResumeStatusResponse>) {
    super();
    Object.assign(this, init);
  }
}
